import ToolDao from "../tool-snapshot/tool-snapshot.dao";
import { ParentToolType } from "../tool-snapshot/tool-snapshot.interface";
import { PartMatch, PartMatchGroup } from "./part-matches.interface";

export default class PartMatchDao {
    public static tiHost: string = '';
    public static searchApiUrl: string = '/search/partMatch';

    public static async searchPartMatches(searchTerm: string, locale: string, searchApiUrl?: string, tiHost?: string): Promise<PartMatch[]> {
        PartMatchDao.tiHost = tiHost ? tiHost : '';
        PartMatchDao.searchApiUrl = searchApiUrl ? searchApiUrl : PartMatchDao.searchApiUrl;
        const matches: PartMatch[] = await PartMatchDao.fetchPartMatches(searchTerm, locale);
        return matches;
    }

    public static async fetchPartMatches(searchTerm: string, locale: string): Promise<PartMatch[]> {
        searchTerm = searchTerm.trim().toUpperCase();
        const url = `${PartMatchDao.tiHost}${PartMatchDao.searchApiUrl}?searchTerm=${searchTerm}&locale=${locale}`;
        const response = await fetch(url);
        if (!response.ok) {
            return null;
        }
        const json = await response.json();
        if (!json) {
            return null;
        }

        const match: PartMatch[] = json as Array<PartMatch>;

        const validMatches = Promise.all(
            match.map(part => part.parentToolTypeId === ParentToolType.REFERENCE_DESIGNS
                ? ToolDao.checkValidToolFolderUrl(this.tiHost, part.folderUrl)
                    .then(valid => valid ? part : null)
                : Promise.resolve(part))
        ).then(matches => matches.filter(p => p));

        return validMatches;
    }

    public static groupPartMatches(partMatches: PartMatch[]): PartMatchGroup[] {

        const partMatchMap = partMatches.reduce((map, part) => {
            const isDevice = part.partType === 'device';
            let key = isDevice ? part.familyId : part.toolTypeId;
            if (map.has(key)) {
                map.get(key).matches.push(part);
            } else {
                const partMatchGroup: PartMatchGroup = {
                    isDevice: isDevice,
                    group: isDevice ? part.familyName : part.toolType,
                    url: isDevice ? part.familyUrl : null,
                    matches: [part]
                }
                map.set(key, partMatchGroup);
            }
            return map;
        }, new Map);

        const partMatchGroups: PartMatchGroup[] = Array.from(partMatchMap.values());

        return PartMatchDao.reorderPartMatchesByEmphasisFlag(partMatchGroups);
    }

    public static reorderPartMatchesByEmphasisFlag = (
      partMatches: PartMatchGroup[],
    ): PartMatchGroup[] => {
      return partMatches.map((partMatch) => {
        if (!partMatch.isDevice) {
          return { ...partMatch, matches: partMatch.matches.map((m) => ({ ...m })) };
        }
        let deEmphasizedParts = [];
        let emphasizedParts = [];
        partMatch.matches.forEach((match) => {
          if (match.emphasized) {
            emphasizedParts.push({ ...match });
          } else {
            deEmphasizedParts.push({ ...match });
          }
        });
        return { ...partMatch, matches: emphasizedParts.concat(deEmphasizedParts) };
      });
    };

    /**
     * Method to reorder PartMatch data based on provided priorityFamilyName
     */
    public static prioritizeFamilyPartMatches(priorityFamilyName: string, partMatchGroups: PartMatchGroup[]):PartMatchGroup[] {
        if (priorityFamilyName === null || priorityFamilyName === '' || !partMatchGroups) {
          return partMatchGroups;
        }
        const priorityFamilies: PartMatchGroup[] = [];
        const otherMatchGroups: PartMatchGroup[] = [];
        partMatchGroups.forEach((p)=>{
          if(p.isDevice && p.group === priorityFamilyName){
            priorityFamilies.push({ ...p, matches: p.matches.map((m) => ({ ...m }))});
          }
          else {
            otherMatchGroups.push({ ...p, matches: p.matches.map((m) => ({ ...m }))});
          }
        });
        return priorityFamilies.concat(otherMatchGroups);
    }

}
